import LanguageCode from '@alltrails/shared/types/LanguageCode';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import useLanguageRegionCode from './useLanguageRegionCode';

export default function useLanguageCode(): LanguageCode {
  const languageRegionCode: LanguageRegionCode = useLanguageRegionCode();
  return languageRegionCode.split('-')[0] as LanguageCode;
}
